module.exports = __webpack_public_path__ + "static/img/pic1.b655ecf.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/video/pic1.png
// module id = 1715
// module chunks = 2